import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";
import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

export const NunitoItalicFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNirXAHgKbcf2z4e9z5MV0.woff",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.CYRILIC_EXT,
      weight: "400",
      style: "italic"
    },
  },
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNirXAHiabcf2z4e9z5MV0.woff",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.CYRILIC,
      weight: "400",
      style: "italic"
    },
  },
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNirXAHgqbcf2z4e9z5MV0.woff",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.VIETNAMESE,
      weight: "400",
      style: "italic"
    },
  },
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNirXAHg6bcf2z4e9z5MV0.woff",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT,
      weight: "400",
      style: "italic"
    },
  },
  {
    uri: "https://fonts.gstatic.com/s/nunito/v31/XRXK3I6Li01BKofIMPyPbj8d7IEAGXNirXAHjabcf2z4e9z5.woff",
    descriptors: { 
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
      style: "italic"
    },
  },
]; 